import { createAction, props } from '@ngrx/store'
import { UserDashboardAPIModel } from '../../models/api.model'

const actionPrefix = '[dashboard]'

export const load_dashboard_state = createAction(`${actionPrefix} load_dashboard_state`)

export const load_dashboard_success = createAction(
  `${actionPrefix} load_dashboard_success`,
  props<UserDashboardAPIModel>()
)
export const load_dashboard_failure = createAction(`${actionPrefix} load_dashboard_failure`, props<any>())
